import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
import { GetListBaseHistoryBO} from './employee-payroll.model';

@Injectable({
    providedIn: 'root'
  })

  export class EmployeeworkHistoryService extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
      super();
    }

    public executeworkhistory(WHState: GetListBaseHistoryBO ): void {
      this.getworkhistory(WHState).subscribe(x => super.next(x));
    }

    getworkhistory(WHState: GetListBaseHistoryBO): Observable<DataStateChangeEventArgs> {
      return this.http.post<any>("api/WorkHistory/GetWorkHistory", WHState)
        .pipe(map(
          (response: any) =>
            <any>{
              result: response['result'],
              count: response['count']
            }
        ))
  
    }
}